import forEach from 'util/for-each'

const loadMoreButtons = document.querySelectorAll('.js-loadContent')

/**
 * isContentEnd check to see if we are at the end of the content and returns boolean.
 *
 * @param {String} page
 * @param {Int} totalPages
 * @returns {Boolean}
 */
function isContentEnd (page, totalPages) {
    return parseInt(page, 10) === totalPages
}

/**
 *  updateLoadMore just updates the load more button data attributes.
 *
 * @param {HTMLElement} el HTML element
 * @param {Int} data Response data from the fetch
 */
function updateLoadMore (el, page) {
    el.setAttribute('data-page', page)
}

/**
 * loadContent loads more content based on content type
 *
 * @param {Object} {contentType, contentTarget, page, initiator}
 */
function loadContent ({contentType, contentTarget, page, initiator}) {
    // Get local from blizzard object
    const locale = window.blizzard.locale
    switch (contentType) {
    case 'blog-cards' :

        // Calc next page to load
        const nextPage = parseInt(page) + 1

        // Fetch next content
        fetch(`/${locale}/newsajax?page=${nextPage}`)
            .then(r => r.json())
            .then(data => {
                // If the next iteration will not have content, we disable the button
                if (isContentEnd(data.page, data.totalPages)) {
                    initiator.setAttribute('disabled', true)
                }

                // Set container targer, innerHTML append, and new cards array
                const container = document.querySelector(contentTarget)
                container.innerHTML += data.html
                const newHiddenCards = [...container.querySelectorAll('.is-invisible')]

                // Update opacity loop for dynamic content entrances
                let hiddenIndex = 0
                const updateOpacity = () => {
                    // Nested RAF for sequence animation
                    window.requestAnimationFrame(() => {
                        window.requestAnimationFrame(() => {
                            newHiddenCards[hiddenIndex].classList.remove('is-invisible')
                            if (hiddenIndex !== newHiddenCards.length - 1) {
                                hiddenIndex += 1
                                updateOpacity()
                            }
                        })
                    })
                }

                updateOpacity()

                // Update load more button
                updateLoadMore(initiator, nextPage)
            })

        break
    default :
        console.warn('Please set a valid content type for the load more function.')
    }
}

// Check for available load more buttons.
if (loadMoreButtons) {
    forEach(loadMoreButtons, (btn) => {
        btn.addEventListener('click', () => {
            // Set options to pass to load content function
            const options = {
                contentType: btn.getAttribute('data-content-type'),
                contentTarget: btn.getAttribute('data-content-target'),
                page: btn.getAttribute('data-page'),
                initiator: btn
            }

            // Call to load content
            loadContent(options)
        })
    })
}
